<template>
  <div class="container pap-form x">
    <div class="row align-items-center">
      <div class="col-md-6 x">
        <div class="image-wrapper image-wrapper--width-300">
          <img
            src="https://pixapup.com/wp-content/uploads/2020/12/dog-nose-page-not-found.jpg"
            alt=""
          />
        </div>
      </div>
      <div class="col-md-6 text-center pt-3 x">
        <h2 class="font-weight-bold">404 Error</h2>
        <h4>Page not found:</h4>
        <p>{{ path }}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    path() {
      return this.$route.fullPath;
    },
  },
};
</script>

<style>
</style>